import styled, { css } from 'styled-components'
import { LargeWrapper, Wrapper, Button, H1 } from '@raysync/common/components'
import { Media } from '@raysync/common/theme'
import RibbonBg from './tab.png'
export const Title = styled.h2`
  padding-top: ${p => (p.top ? p.top + 'px' : '0')};
  padding-bottom: ${p => (p.bottom ? p.bottom + 'px' : '0')};
  font-size: 36px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  color: ${p => p.theme.color.textDarkPlus};
  ${Media.phone`
    font-size: .36rem;
    line-height: 1.2;
    padding-top: ${p => (p.top ? p.top / 100 + 'rem' : '0')};
    padding-bottom: ${p => (p.bottom ? p.bottom / 100 + 'rem' : '0')};
  `}
`
export const JaTitle = Title

export const Desc = styled.p`
  padding-top: ${p => (p.top ? p.top + 'px' : '0')};
  padding-bottom: ${p => (p.bottom ? p.bottom + 'px' : '0')};
  max-width: 1200px;
  margin: 0 auto;
  font-size: ${({ locale }) => (locale === 'ja' ? '18px' : '16px')};
  color: #788296;
  line-height: 1.5;
  text-align: center;
  ${Media.phone`
    max-width: 100%;
    font-size: .2rem;
    padding: ${p => (p.top ? p.top / 100 + 'rem' : '0')} 0 ${p => (p.bottom ? p.bottom / 100 + 'rem' : '0')}; 
  `}
`

// export const BannerWrap = styled.div`
//   position: relative;
//   /* background-color: ${p => p.theme.color.panel}; */
//   height: 520px;
//   ${Media.phone`
//       height: 14rem;
//   `}
// `
// export const BannerContainer = styled.div`
//   position: relative;
//   display: flex;
//   justify-content: space-between;
// `
export const BannerLeftBox = styled.div`
  width: 640px;
  > h1 {
    font-size: 48px;
    line-height: 1;
    font-weight: bold;
    margin: 160px 0 0px;
  }
  > h2 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    line-height: 1.2;
  }
  > p {
    font-size: 16px;
    margin-bottom: 22px;
    color: ${p => p.theme.color.textDarkPlus};
    line-height: 24px;
    opacity: 0.8;
  }
  ${Media.phone`
    width: 100%;
    > h1 {
      font-size: .6rem;
      margin: 2.58rem 0 0;
    }
    > h2 {
      font-size: .24rem;
      margin-bottom: .3rem;
    }
    > p {
      font-size: .2rem;
      margin-bottom: .3rem;
      line-height: .3rem;
    }
  `}
`
export const OffBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  svg {
    width: 64px;
    height: 64px;
    margin-right: 20px;
    margin-left: 16px;
  }
  h4 {
    font-size: 24px;
    line-height: 1;
    color: ${p => p.theme.color.secondary};
    b {
      font-size: 48px;
    }
  }
  p {
    font-size: 16px;
    font-weight: bold;
    color: #201f26;
    line-height: 1.5;
  }
  ${Media.phone`
    margin-bottom:.3rem;
    svg {
      width: .96rem;
      height: .96rem;
      margin-right: .3rem;
      margin-left: .1rem;
    }
    h4 {
      font-size: .36rem;
      b {
        font-size: .78rem;
      }
    }
    p {
      font-size: .24rem;
    }
  `}
`
export const SmbButton = styled(Button)`
  min-width: 400px;
  line-height: 1;
  height: 44px;
  border-radius: 22px;
  svg {
    width: 21px;
    height: 28px;
    margin-left: 33px;
  }
  ${Media.phone`
    min-width: 3.5rem;
    height: .6rem;
    svg{
      width: .3rem;
      height: .27rem;
      margin-left: .18rem;
    }
  `}
`

export const Ribbon = styled.div`
  position: absolute;
  top: 58px;
  right: -12px;
  background: url(${RibbonBg}) no-repeat 100% 100%/100% 100%;
  width: 174px;
  height: 134px;
  color: #fff;
  text-align: center;
  h6 {
    font-size: 18px;
    font-weight: bold;
    margin-top: 4px;
  }
  p {
    line-height: 1;
    span {
      font-size: 24px;
      font-weight: bold;
      b {
        font-size: 36px;
        font-weight: bold;
        line-height: 1;
      }
    }
  }
  > span {
    font-size: 12px;
  }
  ${Media.phone`
    top: .88rem;
    right: -.05rem;
    width: 2.6rem;
    height: 2rem;
    h6 {
      margin-top: .1rem;
      font-size: .27rem;
    }
     p span {
       font-size: .36rem;
        b {
         font-size: .54rem;
         line-height: 1;
        }
      }
      >span {
        font-size:.18rem;
      }
  `}
`
export const FeatureSection = styled(LargeWrapper)`
  margin-bottom: 100px;
  ${Media.phone`
      padding-bottom: .8rem;
  `}
`
export const FeatureContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: ${p => (p.reverse ? 'row-reverse' : 'unset')};
  margin-top: 118px;
  > div {
    width: 600px;
    h3 {
      font-size: 30px;
      line-height: 1;
      font-weight: bold;
      color: ${p => p.theme.color.textDarkPlus};
    }
    p,
    h4 {
      font-size: 16px;
      color: ${p => p.theme.color.textDarkPlus};
      line-height: 1.5;
      margin: 24px 0 20px;
    }
    p {
      color: #788296;
    }
    ul {
      li {
        color: #788296;
        padding-left: 0;
        &::before {
          content: '·';
          display: inline-block;
          width: 4px;
          height: 4px;
          margin-right: 4px;
          background: #788296;
          border-radius: 50%;
          line-height: 6px;
        }
        &::marker {
          display: none;
          font-size: 0;
        }
      }
    }
  }
  svg {
    width: 600px;
    /* margin-right: 60px; */
  }
  ${Media.phone`
    display:block;
    margin-top: .44rem;
    > div {
      width: 100%;
      h3 {
        font-size: .3rem;
      }
      p,h4 {
        font-size: .2rem;
        margin: .18rem 0;
      }
      li {
        font-size: .2rem;
       &::before {
          line-height: 4px;
        }
      }
    }
    svg {
      display:block;
      width: 5.8rem;
      max-height: 2.8rem;
      margin: .2rem auto .44rem;
    }
  `}
`

export const VsSection = styled.div`
  background: ${p => p.theme.color.panel};
  padding: 80px 0;
  ${Media.phone`
    padding: .9rem 0;
  `}
`
export const VsBox = styled.div`
  display: flex;
  justify-content: center;
  img {
    width: 544px;
    &:not(:last-child) {
      margin-right: 80px;
    }
  }
  ${Media.phone`
    img {
      width: 3.2rem;
      &:not(:last-child) {
        margin-right: .25rem;
      }
    }
  `}
`
export const ChooseSection = styled(LargeWrapper)`
  max-width: ${({ locale }) => (locale === 'ja' ? '1400px' : '')};
  width: ${({ locale }) => (locale === 'ja' ? '1400px' : '')};
  padding: 80px 0 94px;
  ${Media.phone`
    padding: .8rem 0.3rem;
  `}
`

export const ChooseDesc = styled(Desc)`
  max-width: 840px;
  padding-left: 0;
  padding-right: 0;
  line-height: 1;
  span b {
    font-size: 24px;
    font-weight: bold;
    color: ${p => p.theme.color.secondary};
  }
  ${Media.phone`
    span b {
      font-size: .2rem;
      font-weight: 400;
      /* color: unset; */
    }
  `}
`
export const EffectBox = styled.div`
  box-shadow: 0px 0px 30px 0px #f0f1f1;
  border-radius: 20px;
  display: flex;
  justify-content: space-around;
  margin: 40px 0 0;
  div {
    margin: 60px 0 50px;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 60px;
      font-weight: bold;
      text-align: center;
      color: ${p => p.theme.color.secondary};
      svg {
        width: 24px;
        height: 45px;
        margin-left: 6px;
      }
    }
    p {
      text-align: center;
      color: ${p => p.theme.color.textDarkPlus};
    }
  }
  ${Media.phone`
    margin: .5rem 0 0;
    div {
      width: 33.33%;
      margin: .6rem 0 .5rem;
      span {
        font-size: .6rem;
        svg {
          width: .24rem;
          height: .45rem;
        }
      }
    }
    p {
      font-size: .2rem;
      text-align: center;
      padding:0 .2rem;
    }
  `}
`
export const ChooseBox = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 68px;
  ${Media.phone`
    margin-top: .68rem;
  `}
`
export const ChooseItem = styled.div`
  width: 450px;
  height: 242px;
  border: 1px solid #e2e5e7;
  border-radius: 20px;
  padding: 30px 40px 0;
  margin-bottom: 26px;
  svg {
    width: 48px;
    height: 48px;
  }
  h3,
  h4 {
    font-size: 20px;
    font-weight: bold;
    color: ${p => p.theme.color.textDarkPlus};
    margin: 14px 0 10px;
  }
  p {
    font-size: 16px;
    color: #636772;
    line-height: 1.5;
    a {
      color: ${p => p.theme.color.textDarkPlus};
      text-decoration: underline;
    }
  }
  ${Media.phone`
    width: 100%;
    height: unset;
    padding: .28rem .3rem;
    margin-bottom: .28rem;
    border-radius: .2rem;
    svg {
      width: .48rem;
      height: .48rem;
    }
    h3,h4 {
      font-size: .3rem;
      margin: .14rem 0;
    }
    p {
      font-size: .18rem;
      line-height:${({ locale }) => (locale === 'ja' ? '.24rem' : '')}
    }
  `}
`

export const CoreSection = styled.div`
  padding: 80px 0 96px;
  background: ${p => p.theme.color.panel};
  svg {
    display: block;
    width: 1152px;
    margin: 50px auto 0;
  }
  ${Media.phone`
    padding: .8rem 0.3rem .96rem;
    svg {
      max-width: 100%;
      margin: .5rem auto 0;
    }
  `}
`
export const CoreSubTitle = styled.h3`
  text-align: center;
  margin: 0 0 24px;
  color: ${p => p.theme.color.textDarkPlus};
`
export const CoreDesc = styled(Desc)`
  a {
    color: ${p => p.theme.color.textDarkPlus};
    text-decoration: underline;
  }
`
export const XmasDate = styled.h4`
  width: 360px;
  height: 40px;
  background: #214e54;
  box-shadow: inset 6px 8px 10px 0px rgba(16, 57, 62, 0.75);
  border-radius: 20px;
  line-height: 40px;
  text-align: center;
  color: #fcf5f5;
  font-size: 16px;
  ${Media.phone`
    width: 5.4rem;
    height: .6rem;
    line-height: .6rem;
    border-radius: .3rem;
    font-size: .24rem;
    margin: 0px auto 0;
  `}
`
export const XmasTitle = styled.h2`
  font-size: 60px;
  line-height: 1;
  font-weight: bold;
  color: #10393e;
  text-align: left;
  margin-top: 18px;
  ${Media.phone`
    font-size:.72rem;
    margin-top: .3rem;
    line-height: .8rem;
    text-align: center;
  `}
`
export const XmasDesc = styled.p`
  font-size: 24px;
  line-height: 1;
  font-weight: bold;
  color: #214e54;
  margin: 12px 0 20px;
  text-align: left;
  span {
    font-weight: bold;
    color: ${p => p.theme.color.secondary};
  }
  ${Media.phone`
    font-size: .24rem;
    margin: .3rem 0 .4rem;
    text-align: center;
  `}
`
export const XmasButton = styled(SmbButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 20px;
    height: 18px;
    margin-left: 8px;
  }
  ${Media.phone`
    margin: 0 auto;
  `}
`
export const XmasContainer = styled.div`
  position: relative;
  padding-top: 120px;
  ${Media.phone`
    padding-top: 2.8rem;
  `}
`
export const EnterpriseSection = styled(LargeWrapper)`
  padding-top: 80px;
  ${Media.phone`
    padding-top: .6rem;
  `}
`
export const ImproveBox = styled(EffectBox)`
  p {
    font-size: 20px;
  }
  ${Media.phone`
    p {
      font-size: .2rem;
    }
  `}
`
export const ProvidesSection = styled.div`
  padding: 80px 0 104px;
  background: ${p => p.theme.color.panel};
  ${Desc} {
    line-height: 1;
  }
  ${Media.phone`
    padding: .8rem 0 .104rem;
    ${Desc} {
    line-height: 1.5;
    }
  `}
`
export const ProvidesBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 46px;
  ${Media.phone`
    flex-wrap: wrap;
  `}
`
export const ProvidesItem = styled(ChooseItem)`
  width: 335px;
  height: 300px;
  background: #fff;
  padding-top: 50px;
  padding-right: 30px;
  margin-bottom: 0;
`
export const ArchSection = styled(LargeWrapper)`
  padding: 80px 0 70px;
  svg {
    margin: 0 auto;
  }
  ${Media.phone`
    padding: .8rem 0.2rem .7rem;
  `}
`
export const DocumentSection = styled.div`
  padding: 80px 0;
  background: ${p => p.theme.color.panel};
  ${Media.phone`
    padding: .8rem 0;
  `}
`
export const BannerIconBox = styled.div`
  display: flex;
  margin: 30px 0 40px;
  ${Media.phone`
    /* justify-content: space-between; */
    margin: .4rem 0 .8rem;
  `}
`
export const BannerIconItem = styled.div`
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 10px 15px 15px 0px rgba(228, 228, 231, 0.2);
  padding: 15px 20px 12px;
  margin-right: 20px;
  display: flex;
  svg {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }
  span {
    display: block;
    color: #333;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
  }
  p {
    font-size: 14px;
    color: #666;
    margin-top: 4px;
  }
  ${Media.phone`
    padding: .24rem;
    margin-right: unset;
    border-radius: .08rem;
    display: ${p => (p.isSmb ? 'flex' : 'block')};
    box-shadow: 7.5px 11.25px 11.25px 0px rgba(228, 228, 231, 0.2);
    &:not(:last-child) {
      margin-right: .24rem;
    }
    svg {
      width: .28rem;
      height: .28rem;
      margin-right: .12rem;
      margin-bottom: .1rem;
      display: block;
    }
    span {
      font-size: .28rem;
    }
    p {
      font-size: .24rem;
      margin-top: .08rem;
    }
  `}
`
export const BannerContainer = styled.div`
  ${({ theme: { color } }) => css`
    position: relative;
    height: 460px;
    overflow: hidden;
    ${Media.phone`
      height: 12rem;
      button {
        margin: .8rem 0 .6rem;
      }
   `}
  `}
`
export const EnterpriseBannerContainer = styled(BannerContainer)`
  ${Media.phone`
    height: 10.5rem;
  `}
`

export const BannerLeft = styled.div`
  min-width: 566px;
  ${Media.phone`
    min-width: unset;
    width: 100%;
  `}
`
export const BannerTitle = styled(H1)`
  line-height: 1;
  display: flex;
  span {
    font-size: 48px;
    font-weight: 700;
  }
  b {
    color: ${p => p.theme.color.secondary};
  }
  ${Media.phone`
    margin: .8rem 0 .1rem;
    font-size: unset;
    text-align: center;
    span {
      font-size: .6rem;
    }
  `}
`
export const BannerDesc = styled.p`
  font-size: 20px;
  line-height: 1.4;
  margin-top: 8px;
  color: ${p => p.theme.color.textDarkPlus};
  ${Media.phone`
      margin: 0 auto;
      max-width: 100%;
      font-size: .28rem;
      line-height: 1.5;
  `}
`

export const BannerWrap = styled(Wrapper)`
  height: 100%;
  width: 1280px;
  min-width: 1280px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${Media.phone`
    display: block;
    padding: 0 .4rem;
  `}
`
export const VideoWrapper = styled.div`
  width: 600px;
  min-width: 600px;
  height: 340px;
  border-radius: 10px;
  iframe {
    border-radius: 10px;
  }
  ${Media.phone`
    width: 100%;
    min-width: unset;
    height: 3.8rem;
  `}
`
export const BannerRight = styled.div`
  img {
    width: 560px;
    display: block;
  }
  ${Media.phone`
     img {
      width: 100%;
       margin: 0.5rem auto 0;
     }
  `}
`
